import React from "react";
import axios from "axios";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { PrintButton } from "../../components/printButton";
import { t } from "../../localization/localization";

const { ExportCSVButton } = CSVExport;

export default class Courses extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const crisId = urlSearchParams.get("crisId");
    axios
      .get(`${window._env_.BASE_URL}/gcris-api/researcher/${crisId}/courses`)
      .then((res) => {
        this.setState({
          data: res.data.map((e) => {
            return {
              id:
                e.code + e.title + e.credits + e.students + e.year + e.semester,
              ...e,
            };
          }),
        });
      });
  }

  render() {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const locale = urlSearchParams.get("locale") ?? "tr";

    const options = {
      sizePerPage: 10,
      hideSizePerPage: true,
      hidePageListOnlyOnePage: true,
    };
    const columns = [
      {
        dataField: "code",
        text: t(locale, "/rs/courses/code"),
        headerStyle: { width: "100px" },
        sort: true,
      },
      {
        dataField: "title",
        text: t(locale, "/rs/courses/title"),
      },
      {
        dataField: "credits",
        text: t(locale, "/rs/courses/credits"),
        headerStyle: { width: "120px" },
        sort: true,
      },
      {
        dataField: "students",
        text: t(locale, "/rs/courses/students"),
        headerStyle: { width: "120px" },
        sort: true,
      },
      {
        dataField: "year",
        text: t(locale, "/rs/courses/year"),
        headerStyle: { width: "100px" },
        sort: true,
      },
      {
        dataField: "semester",
        text: t(locale, "/rs/courses/semester"),
        headerStyle: { width: "120px" },
        sort: true,
      },
    ];
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <PrintButton />
        <ToolkitProvider
          keyField="id"
          data={this.state.data}
          columns={columns}
          exportCSV={{
            fileName: "courses.csv",
            noAutoBOM: false,
          }}
        >
          {(props) => (
            <>
              <ExportCSVButton
                style={{
                  marginBottom: 8,
                }}
                {...props.csvProps}
              >
                <FontAwesomeIcon icon={faDownload} color="#212529" />
                <span style={{ marginLeft: 8 }}>Export CSV</span>
              </ExportCSVButton>
              <BootstrapTable
                {...props.baseProps}
                class={"w-auto"}
                bootstrap4
                striped
                condensed
                keyField="id"
                data={this.state.data}
                columns={columns}
                pagination={paginationFactory(options)}
              />
            </>
          )}
        </ToolkitProvider>
      </div>
    );
  }
}
